import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

/** Route-level twin of the error boundary, for errors thrown during routing or rendering. */
export function RouteErrorScreen() {
  const error = useRouteError();
  const navigate = useNavigate();

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error';

  return (
    <main className="error-screen" role="alert">
      <h1>That page went missing</h1>
      <p className="lede">
        We could not open that part of Thrive Games. The rest of the app is still fine.
      </p>
      <p>
        <button
          type="button"
          className="button button--primary"
          onClick={() => {
            void navigate('/');
          }}
        >
          Back to the start
        </button>
      </p>
      <details>
        <summary>Details for a grown-up</summary>
        <pre>{detail}</pre>
      </details>
    </main>
  );
}
